import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tests-activities',
  templateUrl: './tests-activities.component.html',
  styleUrls: ['./tests-activities.component.scss']
})
export class TestsActivitiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
